import { FC } from 'react';
import { Trans } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

interface AudienceTemplateLinkMessageProps {
  audienceName: string;
  templateName: string;
  classNames?: string;
}

export const AudienceTemplateLinkMessage: FC<AudienceTemplateLinkMessageProps> = ({ audienceName, templateName, classNames }) => {
  return (
    <p className={twMerge('text-sm text-tertiary-600', classNames)}>
      <Trans
        i18nKey='campaign:connectAudienceToDestinations'
        values={{
          audienceName,
          destinationsName: templateName,
        }}
        components={{
          strongBlue: <span className='font-bold text-brand-700' />,
        }}
      />
    </p>
  );
};
